import { Link } from "react-router-dom";
import { useSettings } from "../context/SettingsContext";
import { formatPrice } from "../lib/api";
import { Card } from "../components/ui/card";
import { Truck, CreditCard, Clock, PackageCheck } from "lucide-react";
import { Seo, breadcrumb } from "../lib/seo";

export default function Spedizioni() {
  const { settings } = useSettings();
  const shipCost = settings?.shipping_cost ?? 6;
  const freeThr = settings?.free_shipping_threshold ?? 60;
  const dmin = settings?.delivery_days_min ?? 2;
  const dmax = settings?.delivery_days_max ?? 5;
  const crumb = breadcrumb([{ name: "Home", path: "/" }, { name: "Spedizione e consegna", path: "/spedizioni" }]);

  const rows = [
    { icon: Truck, t: "Costo di spedizione", d: `${formatPrice(shipCost)} per ordine.` },
    { icon: PackageCheck, t: "Spedizione gratuita", d: `Per ordini pari o superiori a ${formatPrice(freeThr)}.` },
    { icon: Clock, t: "Tempi di consegna", d: `${dmin}-${dmax} giorni lavorativi dal buon esito del pagamento.` },
    { icon: CreditCard, t: "Pagamento", d: "Online con carta tramite checkout protetto Stripe." },
  ];

  return (
    <div className="mx-auto max-w-3xl px-6 py-14" data-testid="spedizioni-page">
      <Seo
        title="Spedizione e consegna | Herbalife Rossano"
        description="Costi di spedizione, soglia per la spedizione gratuita, tempi di consegna e modalità di pagamento del negozio online di prodotti Herbalife."
        canonical="/spedizioni"
        jsonLd={crumb}
      />
      <h1 className="text-3xl sm:text-4xl font-extrabold font-display text-slate-900 flex items-center gap-3"><Truck className="w-8 h-8 text-emerald-600" /> Spedizione e consegna</h1>
      <p className="mt-4 text-slate-600 leading-relaxed">Di seguito le informazioni sulla spedizione e sul pagamento, così come configurate per il negozio online.</p>
      <div className="mt-8 grid sm:grid-cols-2 gap-4">
        {rows.map((r) => (
          <Card key={r.t} className="p-5 rounded-2xl border-slate-200 flex items-start gap-3">
            <div className="p-2.5 rounded-xl bg-emerald-50 text-emerald-600 shrink-0"><r.icon className="w-5 h-5" /></div>
            <div><h2 className="font-semibold text-slate-900">{r.t}</h2><p className="mt-1 text-sm text-slate-600">{r.d}</p></div>
          </Card>
        ))}
      </div>
      <p className="mt-8 text-sm text-slate-500">Le condizioni complete di vendita sono disponibili nella pagina <Link to="/termini" className="text-primary hover:underline">Termini e Condizioni</Link>. Per domande specifiche puoi <Link to="/contatta-il-distributore" className="text-primary hover:underline">contattare il distributore</Link>.</p>
    </div>
  );
}
